import images from "./images";

const menu = {
    appetizersCategory: [
        {
            id: 1,
            image: images.starter1,
            title: "Cheese Stick",
            content: "Crunchy and cheesy sticks, perfect for a quick bite.",
            details: {
                price: "7",
                rating: "4.5/5 (based on 180 reviews)",
                portionSize: "150g",
                preparationTime: "10 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Tomato Ketchup"
            },
            paragraphs: [
                "Savor our golden-brown Cheese Sticks—crispy on the outside, with warm, gooey cheese inside for a satisfying snack experience.",
                "Our Cheese Sticks are a delightful treat featuring a crunchy outer shell filled with perfectly melted cheese. Served fresh and hot, these sticks are an ideal appetizer or quick bite anytime you crave something savory and indulgent."
            ],
            ingredients: [
                "Mozzarella Cheese",
                "Breadcrumbs",
                "All-Purpose Flour",
                "Eggs",
                "Garlic Powder",
                "Oregano",
                "Salt",
                "Black Pepper",
                "Vegetable Oil"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "10g" },
                { label: "Carbohydrates", value: "20g" },
                { label: "Fat", value: "18g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "450mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 2,
            image: images.starter2,
            title: "Chicken Wings",
            content: "Spicy and juicy wings, served with a tangy dipping sauce.",
            details: {
                price: "12",
                rating: "4.7/5 (based on 300 reviews)",
                portionSize: "400g",
                preparationTime: "20 mins",
                allergens: "Soy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein",
                spiceLevel: "Medium",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Chilled Lager"
            },
            paragraphs: [
                "Indulge in our fiery and flavorful Chicken Wings, expertly seasoned and cooked to crispy perfection, then served with a zesty dipping sauce.",
                "Our Chicken Wings are a bold and satisfying starter, marinated in a spicy blend of herbs and spices, fried or baked to achieve a crispy outside and tender inside. Paired with a tangy house-made sauce, they offer the ultimate finger-licking experience."
            ],
            ingredients: [
                "Chicken Wings",
                "Hot Sauce",
                "Soy Sauce",
                "Garlic Powder",
                "Paprika",
                "Black Pepper",
                "Salt",
                "Vegetable Oil",
                "Lime Juice"
            ],
            nutritions: [
                { label: "Calories", value: "420 kcal" },
                { label: "Protein", value: "35g" },
                { label: "Carbohydrates", value: "8g" },
                { label: "Fat", value: "28g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "750mg" },
                { label: "Cholesterol", value: "90mg" }
            ]
        },
        {
            id: 3,
            image: images.starter3,
            title: "Bruschetta",
            content: "Grilled bread topped with fresh tomatoes, basil, and balsamic drizzle.",
            details: {
                price: "8",
                rating: "4.6/5 (based on 180 reviews)",
                portionSize: "250g",
                preparationTime: "10 mins",
                allergens: "Gluten",
                servingTemperature: "Room Temperature",
                dietaryInfo: "Vegetarian, Low-Fat",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Pinot Grigio"
            },
            paragraphs: [
                "Savor the taste of Italy with our classic Bruschetta — crisp grilled bread layered with a vibrant mix of diced tomatoes, fresh basil, and a touch of balsamic glaze.",
                "Our Bruschetta is a delightful starter made from toasted artisanal bread, topped with a refreshing tomato and basil mix, drizzled with rich balsamic reduction. A light and flavorful appetizer perfect for sharing."
            ],
            ingredients: [
                "Toasted Bread Slices",
                "Fresh Tomatoes",
                "Fresh Basil Leaves",
                "Garlic",
                "Olive Oil",
                "Salt",
                "Black Pepper",
                "Balsamic Glaze"
            ],
            nutritions: [
                { label: "Calories", value: "220 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "28g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "4g" },
                { label: "Sodium", value: "350mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 4,
            image: images.starter4,
            title: "Fried Rice",
            content: "Delicious fried rice with vegetables and a hint of soy sauce.",
            details: {
                price: "10",
                rating: "4.7/5 (based on 220 reviews)",
                portionSize: "350g",
                preparationTime: "12 mins",
                allergens: "Soy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian, Low-Fat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Green Tea"
            },
            paragraphs: [
                "Our Fried Rice is a flavorful dish featuring stir-fried rice with a colorful medley of vegetables, seasoned with savory soy sauce and fragrant aromatics.",
                "Prepared with premium long-grain rice, crunchy vegetables, and just the right amount of seasoning, this classic Fried Rice is light yet satisfying, making it an ideal choice for any time of day."
            ],
            ingredients: [
                "Cooked Rice",
                "Carrots",
                "Green Peas",
                "Bell Peppers",
                "Soy Sauce",
                "Garlic",
                "Green Onions",
                "Vegetable Oil",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "320 kcal" },
                { label: "Protein", value: "7g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "3g" },
                { label: "Sodium", value: "550mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 5,
            image: images.starter5,
            title: "Meatballs",
            content: "Savory meatballs in a rich tomato sauce.",
            details: {
                price: "9",
                rating: "4.6/5 (based on 180 reviews)",
                portionSize: "300g",
                preparationTime: "18 mins",
                allergens: "Dairy, Gluten, Eggs",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein",
                spiceLevel: "Medium",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Chianti Red Wine"
            },
            paragraphs: [
                "Our Meatballs are crafted from seasoned ground beef and herbs, simmered slowly in a house-made tomato sauce for a rich and hearty flavor.",
                "Perfectly tender and full of bold Italian spices, these Meatballs are served in a luscious tomato sauce, ideal on their own or paired with crusty bread or pasta."
            ],
            ingredients: [
                "Ground Beef",
                "Breadcrumbs",
                "Parmesan Cheese",
                "Eggs",
                "Garlic",
                "Onion",
                "Tomato Sauce",
                "Olive Oil",
                "Italian Herbs"
            ],
            nutritions: [
                { label: "Calories", value: "400 kcal" },
                { label: "Protein", value: "25g" },
                { label: "Carbohydrates", value: "20g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "700mg" },
                { label: "Cholesterol", value: "80mg" }
            ]
        },
        {
            id: 6,
            image: images.starter6,
            title: "Samosas",
            content: "Golden, crispy pastries filled with spiced potatoes and peas.",
            details: {
                price: "6",
                rating: "4.7/5 (based on 210 reviews)",
                portionSize: "200g",
                preparationTime: "12 mins",
                allergens: "Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegan-Friendly",
                spiceLevel: "Medium",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Masala Chai"
            },
            paragraphs: [
                "Our Samosas are a delightful Indian snack made with a crisp, golden-brown pastry filled with a savory blend of spiced potatoes, peas, and herbs.",
                "Each bite of these flaky pastries delivers a flavorful burst of traditional spices, making them a perfect appetizer or snack for any time of day."
            ],
            ingredients: [
                "All-Purpose Flour",
                "Potatoes",
                "Green Peas",
                "Cumin Seeds",
                "Coriander",
                "Garam Masala",
                "Turmeric",
                "Chili Powder",
                "Salt",
                "Vegetable Oil"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "6g" },
                { label: "Carbohydrates", value: "35g" },
                { label: "Fat", value: "14g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "450mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 7,
            image: images.starter7,
            title: "Stuffed Mushrooms",
            content: "Garlic and herb stuffed mushrooms topped with melted cheese.",
            details: {
                price: "11",
                rating: "4.9/5 (based on 175 reviews)",
                portionSize: "250g",
                preparationTime: "18 mins",
                allergens: "Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian, Low-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Chardonnay"
            },
            paragraphs: [
                "Our Stuffed Mushrooms are filled with a flavorful blend of garlic, herbs, and cream cheese, then baked to golden perfection with melted cheese on top.",
                "Perfectly roasted and rich in flavor, these bite-sized delights offer a warm, cheesy experience that's perfect as a starter or a shareable plate."
            ],
            ingredients: [
                "Button Mushrooms",
                "Cream Cheese",
                "Garlic",
                "Parsley",
                "Thyme",
                "Mozzarella Cheese",
                "Olive Oil",
                "Black Pepper",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "290 kcal" },
                { label: "Protein", value: "10g" },
                { label: "Carbohydrates", value: "8g" },
                { label: "Fat", value: "24g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "3g" },
                { label: "Sodium", value: "380mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 8,
            image: images.starter8,
            title: "Spring Roll",
            content: "Light and crispy rolls filled with vegetables and served with a sweet chili sauce.",
            details: {
                price: "5",
                rating: "4.6/5 (based on 210 reviews)",
                portionSize: "200g",
                preparationTime: "12 mins",
                allergens: "Gluten, Soy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegan, Low-Fat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Iced Green Tea"
            },
            paragraphs: [
                "Our Spring Rolls are perfectly crisp and filled with a medley of seasoned vegetables, offering a light and satisfying starter.",
                "Paired with a sweet chili dipping sauce, these golden rolls provide a delightful crunch with every bite and are a great vegan-friendly option."
            ],
            ingredients: [
                "Spring Roll Wrappers",
                "Cabbage",
                "Carrots",
                "Bell Peppers",
                "Bean Sprouts",
                "Garlic",
                "Soy Sauce",
                "Sesame Oil",
                "Sweet Chili Sauce"
            ],
            nutritions: [
                { label: "Calories", value: "180 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "25g" },
                { label: "Fat", value: "7g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "300mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
    ],

    soupsSaladsCategory: [
        {
            id: 9,
            image: images.salad1,
            title: "Chicken Soup",
            content: "A comforting bowl of hearty chicken soup made with fresh vegetables and herbs.",
            details: {
                price: "10",
                rating: "4.7/5 (based on 190 reviews)",
                portionSize: "350ml",
                preparationTime: "20 mins",
                allergens: "Celery, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Low-Fat, High-Protein",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Garlic Bread"
            },
            paragraphs: [
                "Warm your soul with our classic Chicken Soup, made with tender chicken, garden-fresh vegetables, and aromatic herbs.",
                "Simmered slowly to perfection, this nourishing soup is both light and flavorful, ideal for any season or occasion."
            ],
            ingredients: [
                "Chicken Breast",
                "Carrots",
                "Celery",
                "Onions",
                "Garlic",
                "Parsley",
                "Black Pepper",
                "Salt",
                "Vegetable Broth"
            ],
            nutritions: [
                { label: "Calories", value: "220 kcal" },
                { label: "Protein", value: "25g" },
                { label: "Carbohydrates", value: "10g" },
                { label: "Fat", value: "8g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "4g" },
                { label: "Sodium", value: "550mg" },
                { label: "Cholesterol", value: "55mg" }
            ]
        },
        {
            id: 10,
            image: images.salad2,
            title: "Chicken Noodle Soup",
            content: "A classic comfort soup with tender chicken, egg noodles, and hearty vegetables in a savory broth.",
            details: {
                price: "11",
                rating: "4.9/5 (based on 215 reviews)",
                portionSize: "400ml",
                preparationTime: "25 mins",
                allergens: "Egg, Gluten, Celery",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Toasted Breadsticks"
            },
            paragraphs: [
                "Enjoy the warmth of our Chicken Noodle Soup, packed with tender chunks of chicken, soft egg noodles, and vibrant vegetables in a rich, savory broth.",
                "Perfect for chilly days or when you need a pick-me-up, this nourishing soup is a timeless favorite made with love and care."
            ],
            ingredients: [
                "Chicken Breast",
                "Egg Noodles",
                "Carrots",
                "Celery",
                "Onions",
                "Garlic",
                "Parsley",
                "Chicken Broth",
                "Black Pepper",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "27g" },
                { label: "Carbohydrates", value: "22g" },
                { label: "Fat", value: "9g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "4g" },
                { label: "Sodium", value: "620mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        },
        {
            id: 11,
            image: images.salad3,
            title: "Hot & Sour Soup",
            content: "A flavorful and spicy soup with a balance of hot, sour, and savory notes, packed with vegetables and tofu.",
            details: {
                price: "9",
                rating: "4.5/5 (based on 150 reviews)",
                portionSize: "350ml",
                preparationTime: "20 mins",
                allergens: "Soy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegan, Gluten-Free",
                spiceLevel: "Hot",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Steamed Dumplings"
            },
            paragraphs: [
                "Indulge in the perfect combination of hot and sour flavors with our Hot & Sour Soup. Packed with mushrooms, tofu, and a tangy broth, this soup offers a deliciously spicy experience.",
                "With its bold flavors and satisfying texture, this soup is a must-try for those who love a little heat and a burst of sourness."
            ],
            ingredients: [
                "Tofu",
                "Shiitake Mushrooms",
                "Bamboo Shoots",
                "Soy Sauce",
                "Rice Vinegar",
                "Ginger",
                "Garlic",
                "Chili Paste",
                "Spring Onions",
                "Sesame Oil"
            ],
            nutritions: [
                { label: "Calories", value: "190 kcal" },
                { label: "Protein", value: "10g" },
                { label: "Carbohydrates", value: "14g" },
                { label: "Fat", value: "12g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "890mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 12,
            image: images.salad4,
            title: "Tomato Soup",
            content: "A creamy and comforting bowl of tomato soup, perfect for any season, made with ripe tomatoes and fresh herbs.",
            details: {
                price: "8",
                rating: "4.6/5 (based on 180 reviews)",
                portionSize: "350ml",
                preparationTime: "15 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Grilled Cheese Sandwich"
            },
            paragraphs: [
                "Our Tomato Soup is the perfect comfort food, offering a smooth, velvety texture and a rich, tangy flavor that will warm you from the inside out.",
                "Made with the freshest, juiciest tomatoes, a touch of cream, and aromatic herbs, this soup is a classic that never goes out of style."
            ],
            ingredients: [
                "Ripe Tomatoes",
                "Onions",
                "Garlic",
                "Olive Oil",
                "Cream",
                "Basil",
                "Oregano",
                "Vegetable Broth",
                "Salt",
                "Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "180 kcal" },
                { label: "Protein", value: "3g" },
                { label: "Carbohydrates", value: "22g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "8g" },
                { label: "Sodium", value: "650mg" },
                { label: "Cholesterol", value: "30mg" }
            ]
        },
        {
            id: 13,
            image: images.salad5,
            title: "Chicken Caesar Salad",
            content: "A fresh and flavorful Chicken Caesar Salad, featuring grilled chicken, crisp romaine lettuce, and creamy Caesar dressing.",
            details: {
                price: "12",
                rating: "4.8/5 (based on 250 reviews)",
                portionSize: "300g",
                preparationTime: "15 mins",
                allergens: "Fish, Dairy, Gluten",
                servingTemperature: "Cold",
                dietaryInfo: "High-Protein, Low-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Sauvignon Blanc"
            },
            paragraphs: [
                "Enjoy our fresh and flavorful Chicken Caesar Salad, a perfect blend of crisp romaine lettuce, grilled chicken, crunchy croutons, and creamy Caesar dressing.",
                "Our Chicken Caesar Salad is a classic favorite, featuring tender grilled chicken breast on a bed of crisp romaine lettuce, topped with crunchy croutons and a generous sprinkle of Parmesan cheese. Finished with our house-made Caesar dressing, this dish is both delicious and satisfying."
            ],
            ingredients: [
                "Grilled Chicken Breast",
                "Romaine Lettuce",
                "Parmesan Cheese",
                "Croutons",
                "Caesar Dressing",
                "Fresh Lemon Juice",
                "Anchovy Paste",
                "Black Pepper",
                "Garlic"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "30g" },
                { label: "Carbohydrates", value: "15g" },
                { label: "Fat", value: "20g" },
                { label: "Fiber", value: "5g" },
                { label: "Sugars", value: "3g" },
                { label: "Sodium", value: "600mg" },
                { label: "Cholesterol", value: "70mg" }
            ]
        },
        {
            id: 14,
            image: images.salad6,
            title: "Spinach Salad",
            content: "A refreshing and nutritious Spinach Salad, topped with fresh veggies and a light vinaigrette dressing.",
            details: {
                price: "10",
                rating: "4.5/5 (based on 180 reviews)",
                portionSize: "250g",
                preparationTime: "10 mins",
                allergens: "Nuts",
                servingTemperature: "Cold",
                dietaryInfo: "Vegan, Low-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Crisp White Wine"
            },
            paragraphs: [
                "This fresh Spinach Salad is made with tender spinach leaves, complemented by a mix of crunchy vegetables, and topped with a light vinaigrette dressing.",
                "Packed with nutrients and full of flavor, this salad is perfect for a light and healthy meal any time of the day."
            ],
            ingredients: [
                "Fresh Spinach Leaves",
                "Cucumber",
                "Cherry Tomatoes",
                "Red Onion",
                "Carrots",
                "Almonds",
                "Olive Oil",
                "Balsamic Vinegar"
            ],
            nutritions: [
                { label: "Calories", value: "180 kcal" },
                { label: "Protein", value: "6g" },
                { label: "Carbohydrates", value: "14g" },
                { label: "Fat", value: "12g" },
                { label: "Fiber", value: "5g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "250mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 15,
            image: images.salad7,
            title: "Taco Salad",
            content: "A delicious and savory Taco Salad loaded with seasoned beef, fresh veggies, and a crunchy tortilla shell.",
            details: {
                price: "12",
                rating: "4.6/5 (based on 220 reviews)",
                portionSize: "350g",
                preparationTime: "15 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Cold",
                dietaryInfo: "High-Protein",
                spiceLevel: "Medium",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Sour Cream or Guacamole"
            },
            paragraphs: [
                "Our Taco Salad is the perfect blend of flavors, featuring seasoned ground beef, fresh vegetables, and crispy tortilla strips, all tossed in a tangy dressing.",
                "This hearty salad is both satisfying and flavorful, making it a perfect choice for any occasion."
            ],
            ingredients: [
                "Ground Beef",
                "Lettuce",
                "Tomatoes",
                "Onions",
                "Cheddar Cheese",
                "Tortilla Chips",
                "Sour Cream",
                "Taco Dressing"
            ],
            nutritions: [
                { label: "Calories", value: "450 kcal" },
                { label: "Protein", value: "28g" },
                { label: "Carbohydrates", value: "35g" },
                { label: "Fat", value: "22g" },
                { label: "Fiber", value: "6g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "800mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        },
        {
            id: 16,
            image: images.salad8,
            title: "Veg Salad",
            content: "A fresh and vibrant Veg Salad filled with crisp veggies, perfect for a light and healthy meal.",
            details: {
                price: "9",
                rating: "4.5/5 (based on 180 reviews)",
                portionSize: "300g",
                preparationTime: "10 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Vegan, Gluten-Free",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Balsamic Vinaigrette"
            },
            paragraphs: [
                "Our Veg Salad is packed with a variety of fresh vegetables, including crisp lettuce, juicy tomatoes, and crunchy cucumbers, tossed together in a light dressing.",
                "This healthy and refreshing salad is a perfect option for those seeking a low-calorie, nutrient-rich dish."
            ],
            ingredients: [
                "Lettuce",
                "Tomatoes",
                "Cucumbers",
                "Carrots",
                "Red Onion",
                "Bell Peppers",
                "Olives",
                "Balsamic Vinaigrette"
            ],
            nutritions: [
                { label: "Calories", value: "150 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "12g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "350mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        }
    ],

    mainCoursesCategory: [
        {
            id: 17,
            image: images.mainCourse1,
            title: "Burger",
            content: "A juicy and flavorful burger with all the classic toppings, perfect for a satisfying meal.",
            details: {
                price: "12",
                rating: "4.6/5 (based on 220 reviews)",
                portionSize: "250g",
                preparationTime: "15 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Fries"
            },
            paragraphs: [
                "Our Burger is made with a tender, juicy beef patty, topped with fresh lettuce, tomato, pickles, and melted cheese, all sandwiched between a soft, toasted bun.",
                "This classic favorite is a perfect choice for any burger lover, offering a hearty and satisfying meal that's sure to please."
            ],
            ingredients: [
                "Beef Patty",
                "Lettuce",
                "Tomato",
                "Pickles",
                "Cheddar Cheese",
                "Burger Bun",
                "Ketchup",
                "Mustard",
                "Onions"
            ],
            nutritions: [
                { label: "Calories", value: "450 kcal" },
                { label: "Protein", value: "30g" },
                { label: "Carbohydrates", value: "40g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "700mg" },
                { label: "Cholesterol", value: "75mg" }
            ]
        },
        {
            id: 18,
            image: images.mainCourse2,
            title: "Fried Rice",
            content: "A delicious fried rice with vegetables and a hint of soy sauce, perfect for any meal.",
            details: {
                price: "10",
                rating: "4.5/5 (based on 180 reviews)",
                portionSize: "350g",
                preparationTime: "20 mins",
                allergens: "Soy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian, Low-Fat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Spring Rolls"
            },
            paragraphs: [
                "Our Fried Rice is a savory blend of rice, fresh vegetables, and soy sauce, cooked to perfection for a satisfying and tasty dish.",
                "It's the perfect side or main dish for any meal, offering a balanced combination of flavors and textures."
            ],
            ingredients: [
                "Rice",
                "Carrots",
                "Peas",
                "Green Onions",
                "Soy Sauce",
                "Garlic",
                "Egg",
                "Sesame Oil"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "7g" },
                { label: "Carbohydrates", value: "50g" },
                { label: "Fat", value: "12g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "900mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 19,
            image: images.mainCourse3,
            title: "Roast Chicken",
            content: "A perfectly roasted chicken, seasoned with aromatic herbs and spices for a tender and flavorful meal.",
            details: {
                price: "15",
                rating: "4.9/5 (based on 300 reviews)",
                portionSize: "400g",
                preparationTime: "1 hour",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Mashed Potatoes"
            },
            paragraphs: [
                "Our Roast Chicken is marinated with a blend of herbs and spices, then slow-roasted to perfection, ensuring a golden, crispy skin and juicy, tender meat.",
                "This hearty dish is a classic favorite, perfect for any occasion or a comforting family meal."
            ],
            ingredients: [
                "Whole Chicken",
                "Garlic",
                "Rosemary",
                "Thyme",
                "Olive Oil",
                "Lemon",
                "Black Pepper",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "500 kcal" },
                { label: "Protein", value: "50g" },
                { label: "Carbohydrates", value: "5g" },
                { label: "Fat", value: "30g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "600mg" },
                { label: "Cholesterol", value: "100mg" }
            ]
        },
        {
            id: 20,
            image: images.mainCourse4,
            title: "Spaghetti",
            content: "A classic Italian dish with perfectly cooked pasta served with a rich and flavorful tomato sauce.",
            details: {
                price: "13",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "350g",
                preparationTime: "25 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "High-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Garlic Bread"
            },
            paragraphs: [
                "Our Spaghetti is made with al dente pasta, served with a rich tomato sauce simmered to perfection, featuring garlic, onions, and a touch of basil.",
                "This comforting classic is a perfect meal for pasta lovers, offering a satisfying balance of flavors and textures."
            ],
            ingredients: [
                "Spaghetti Pasta",
                "Tomato Sauce",
                "Garlic",
                "Onions",
                "Basil",
                "Olive Oil",
                "Parmesan Cheese",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "550 kcal" },
                { label: "Protein", value: "12g" },
                { label: "Carbohydrates", value: "80g" },
                { label: "Fat", value: "15g" },
                { label: "Fiber", value: "5g" },
                { label: "Sugars", value: "8g" },
                { label: "Sodium", value: "700mg" },
                { label: "Cholesterol", value: "20mg" }
            ]
        },
        {
            id: 21,
            image: images.mainCourse5,
            title: "Pizza",
            content: "A delicious pizza with a crispy crust, topped with fresh ingredients and a savory tomato sauce.",
            details: {
                price: "14",
                rating: "4.9/5 (based on 400 reviews)",
                portionSize: "12-inch",
                preparationTime: "20 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "High-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Soft Drink"
            },
            paragraphs: [
                "Our Pizza features a golden, crispy crust topped with a savory tomato sauce, melted mozzarella cheese, and your choice of fresh toppings.",
                "This classic Italian favorite is perfect for any occasion, offering a satisfying combination of flavors in every bite."
            ],
            ingredients: [
                "Pizza Dough",
                "Tomato Sauce",
                "Mozzarella Cheese",
                "Olive Oil",
                "Fresh Basil",
                "Pepperoni",
                "Mushrooms",
                "Onions",
                "Bell Peppers"
            ],
            nutritions: [
                { label: "Calories", value: "800 kcal" },
                { label: "Protein", value: "30g" },
                { label: "Carbohydrates", value: "95g" },
                { label: "Fat", value: "35g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "8g" },
                { label: "Sodium", value: "1000mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 22,
            image: images.mainCourse6,
            title: "Pasta",
            content: "A rich and creamy pasta dish with perfectly cooked noodles, complemented by a savory sauce.",
            details: {
                price: "11",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "300g",
                preparationTime: "18 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "High-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Red Wine"
            },
            paragraphs: [
                "Our Pasta is made with al dente noodles, smothered in a rich, creamy sauce made from fresh ingredients. A classic comfort food that hits all the right notes.",
                "This hearty pasta dish is perfect for pasta lovers, offering a satisfying blend of flavors that will leave you wanting more."
            ],
            ingredients: [
                "Pasta Noodles",
                "Heavy Cream",
                "Parmesan Cheese",
                "Garlic",
                "Olive Oil",
                "Salt",
                "Black Pepper",
                "Basil"
            ],
            nutritions: [
                { label: "Calories", value: "650 kcal" },
                { label: "Protein", value: "20g" },
                { label: "Carbohydrates", value: "80g" },
                { label: "Fat", value: "30g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "850mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        },
        {
            id: 23,
            image: images.mainCourse7,
            title: "Grilled Salmon",
            content: "Perfectly grilled salmon fillet, seasoned with fresh herbs and served with a side of vegetables.",
            details: {
                price: "18",
                rating: "4.9/5 (based on 450 reviews)",
                portionSize: "250g",
                preparationTime: "20 mins",
                allergens: "Fish, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein, Omega-3",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Chardonnay"
            },
            paragraphs: [
                "Our Grilled Salmon is made from the finest, sustainably sourced salmon fillets, perfectly seasoned and grilled to perfection. It’s paired with a delicious mix of roasted vegetables.",
                "This dish is not only flavorful but also packed with nutrients, making it a healthy and satisfying choice for any meal."
            ],
            ingredients: [
                "Salmon Fillet",
                "Olive Oil",
                "Lemon",
                "Garlic",
                "Rosemary",
                "Thyme",
                "Black Pepper",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "450 kcal" },
                { label: "Protein", value: "35g" },
                { label: "Carbohydrates", value: "5g" },
                { label: "Fat", value: "30g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "700mg" },
                { label: "Cholesterol", value: "75mg" }
            ]
        },
        {
            id: 24,
            image: images.mainCourse8,
            title: "Biryani",
            content: "A flavorful and aromatic rice dish made with fragrant basmati rice, tender meat, and a blend of spices.",
            details: {
                price: "16",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "400g",
                preparationTime: "30 mins",
                allergens: "Gluten, Dairy, Nuts",
                servingTemperature: "Hot",
                dietaryInfo: "High-Protein, Spicy",
                spiceLevel: "Spicy",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Raita, Mango Chutney"
            },
            paragraphs: [
                "Our Biryani is a classic dish made with tender, marinated chicken (or other meats), basmati rice, and a blend of traditional spices, cooked to perfection.",
                "This flavorful, aromatic dish is a feast for the senses, offering a perfect balance of spices, heat, and richness, ideal for any occasion."
            ],
            ingredients: [
                "Basmati Rice",
                "Chicken (or Lamb/Beef)",
                "Onions",
                "Tomatoes",
                "Yogurt",
                "Garlic",
                "Ginger",
                "Cinnamon",
                "Cloves",
                "Cardamom",
                "Cumin",
                "Coriander",
                "Turmeric",
                "Chili",
                "Saffron"
            ],
            nutritions: [
                { label: "Calories", value: "650 kcal" },
                { label: "Protein", value: "40g" },
                { label: "Carbohydrates", value: "70g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "800mg" },
                { label: "Cholesterol", value: "90mg" }
            ]
        }
    ],

    dessertsCategory: [
        {
            id: 25,
            image: images.dessert1,
            title: "Chocolate Cake",
            content: "A rich and decadent chocolate cake layered with velvety smooth frosting, perfect for dessert lovers.",
            details: {
                price: "8",
                rating: "4.9/5 (based on 420 reviews)",
                portionSize: "200g",
                preparationTime: "25 mins",
                allergens: "Gluten, Dairy, Eggs",
                servingTemperature: "Room Temperature",
                dietaryInfo: "High-Sugar, Moderate-Fat",
                spiceLevel: "Sweet",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Vanilla Ice Cream"
            },
            paragraphs: [
                "Indulge in our irresistibly moist and rich Chocolate Cake, made with premium cocoa and topped with a smooth, glossy chocolate frosting.",
                "This decadent dessert is the perfect ending to any meal, offering the perfect balance of sweetness and chocolatey goodness."
            ],
            ingredients: [
                "All-Purpose Flour",
                "Cocoa Powder",
                "Butter",
                "Sugar",
                "Eggs",
                "Milk",
                "Vanilla Extract",
                "Baking Powder",
                "Salt",
                "Heavy Cream"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "20g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "30g" },
                { label: "Sodium", value: "300mg" },
                { label: "Cholesterol", value: "70mg" }
            ]
        },
        {
            id: 26,
            image: images.dessert2,
            title: "Cheese Cake",
            content: "A creamy and smooth cheesecake with a buttery graham cracker crust, topped with fresh fruit or chocolate.",
            details: {
                price: "9",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "250g",
                preparationTime: "30 mins",
                allergens: "Gluten, Dairy, Eggs",
                servingTemperature: "Chilled",
                dietaryInfo: "High-Sugar, High-Fat",
                spiceLevel: "Sweet",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Coffee"
            },
            paragraphs: [
                "Enjoy the smooth, velvety texture of our Cheese Cake, made with the finest cream cheese and topped with a fresh fruit medley or rich chocolate.",
                "This irresistible dessert provides the perfect balance of creamy richness and slight tanginess, making it a favorite for any occasion."
            ],
            ingredients: [
                "Cream Cheese",
                "Graham Crackers",
                "Sugar",
                "Butter",
                "Eggs",
                "Vanilla Extract",
                "Sour Cream",
                "Flour",
                "Lemon Juice"
            ],
            nutritions: [
                { label: "Calories", value: "420 kcal" },
                { label: "Protein", value: "6g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "35g" },
                { label: "Sodium", value: "220mg" },
                { label: "Cholesterol", value: "80mg" }
            ]
        },
        {
            id: 27,
            image: images.dessert3,
            title: "Fruit Tart",
            content: "A delightful tart with a crisp pastry crust, filled with creamy custard and topped with an assortment of fresh, vibrant fruits.",
            details: {
                price: "9",
                rating: "4.7/5 (based on 310 reviews)",
                portionSize: "200g",
                preparationTime: "35 mins",
                allergens: "Gluten, Dairy, Eggs",
                servingTemperature: "Chilled",
                dietaryInfo: "High-Sugar, Moderate-Fat",
                spiceLevel: "Sweet",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Iced Tea"
            },
            paragraphs: [
                "Our Fruit Tart is a perfect blend of a buttery, flaky crust, silky custard, and a colorful selection of fresh fruits, making each bite a burst of flavor.",
                "This dessert is a fresh, light option for those who love a combination of smooth creaminess and vibrant fruitiness."
            ],
            ingredients: [
                "Pastry Crust",
                "Custard Cream",
                "Fresh Berries",
                "Kiwi",
                "Strawberries",
                "Peach Slices",
                "Vanilla Extract",
                "Eggs",
                "Sugar"
            ],
            nutritions: [
                { label: "Calories", value: "330 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "15g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "25g" },
                { label: "Sodium", value: "180mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        },
        {
            id: 28,
            image: images.dessert4,
            title: "Baklava",
            content: "A sweet, flaky pastry made with layers of filo dough, filled with a mixture of finely chopped nuts and sweetened with honey syrup.",
            details: {
                price: "7",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "150g",
                preparationTime: "45 mins",
                allergens: "Gluten, Nuts, Dairy",
                servingTemperature: "Room Temperature",
                dietaryInfo: "High-Sugar, High-Fat",
                spiceLevel: "Sweet",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Turkish Coffee"
            },
            paragraphs: [
                "Baklava is the ultimate indulgence, with its delicate, buttery layers of filo dough, a rich filling of pistachios and walnuts, and a sweet honey syrup that soaks into every bite.",
                "This delicious pastry is a perfect dessert for those who love a crunchy, nutty treat with a hint of sweetness."
            ],
            ingredients: [
                "Filo Dough",
                "Pistachios",
                "Walnuts",
                "Almonds",
                "Butter",
                "Honey",
                "Sugar",
                "Cinnamon",
                "Lemon Juice"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "35g" },
                { label: "Fat", value: "15g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "20g" },
                { label: "Sodium", value: "150mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 29,
            image: images.dessert5,
            title: "Ice Cream",
            content: "A creamy and indulgent ice cream made with the finest ingredients, available in a variety of delicious flavors.",
            details: {
                price: "5",
                rating: "4.7/5 (based on 500 reviews)",
                portionSize: "150g",
                preparationTime: "30 mins",
                allergens: "Dairy, Eggs",
                servingTemperature: "Cold",
                dietaryInfo: "High-Sugar, Moderate-Fat",
                spiceLevel: "Sweet",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Chocolate Cake"
            },
            paragraphs: [
                "Our Ice Cream is made with premium milk and cream, delivering a smooth and rich texture in every scoop. Choose from classic flavors like vanilla, chocolate, and strawberry, or go adventurous with new seasonal options.",
                "This delightful frozen treat is perfect for any occasion, offering a refreshing and sweet way to cool down on a warm day."
            ],
            ingredients: [
                "Milk",
                "Cream",
                "Sugar",
                "Egg Yolks",
                "Vanilla Extract",
                "Chocolate",
                "Strawberries",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "250 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "30g" },
                { label: "Fat", value: "12g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "25g" },
                { label: "Sodium", value: "50mg" },
                { label: "Cholesterol", value: "35mg" }
            ]
        },
        {
            id: 30,
            image: images.dessert6,
            title: "Apple Pie",
            content: "A warm and comforting apple pie with a flaky, buttery crust and a sweet, spiced apple filling.",
            details: {
                price: "7",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "180g",
                preparationTime: "45 mins",
                allergens: "Gluten, Dairy, Eggs",
                servingTemperature: "Warm",
                dietaryInfo: "High-Sugar, Moderate-Fat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Vanilla Ice Cream"
            },
            paragraphs: [
                "Enjoy a slice of our freshly baked Apple Pie, made with tender, spiced apples and encased in a perfectly golden, flaky crust.",
                "This classic dessert is the ultimate comfort food, offering a sweet and slightly tart apple filling, ideal for any occasion or as a delightful treat after a hearty meal."
            ],
            ingredients: [
                "Apples",
                "All-Purpose Flour",
                "Butter",
                "Sugar",
                "Eggs",
                "Cinnamon",
                "Nutmeg",
                "Lemon Juice",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "3g" },
                { label: "Carbohydrates", value: "40g" },
                { label: "Fat", value: "14g" },
                { label: "Fiber", value: "5g" },
                { label: "Sugars", value: "22g" },
                { label: "Sodium", value: "200mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 31,
            image: images.dessert7,
            title: "Cherry Pie",
            content: "A deliciously sweet and tangy cherry pie with a golden, flaky crust and a rich, flavorful filling.",
            details: {
                price: "8",
                rating: "4.9/5 (based on 380 reviews)",
                portionSize: "200g",
                preparationTime: "50 mins",
                allergens: "Gluten, Dairy, Eggs",
                servingTemperature: "Warm",
                dietaryInfo: "High-Sugar, Moderate-Fat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Whipped Cream"
            },
            paragraphs: [
                "Indulge in the perfect balance of sweet and tart with our Cherry Pie, made with ripe, juicy cherries and a flaky, buttery crust.",
                "This crowd-pleasing dessert is a classic favorite, perfect for celebrations or just a comforting treat to enjoy anytime."
            ],
            ingredients: [
                "Cherries",
                "All-Purpose Flour",
                "Butter",
                "Sugar",
                "Eggs",
                "Cornstarch",
                "Cinnamon",
                "Lemon Juice",
                "Salt"
            ],
            nutritions: [
                { label: "Calories", value: "320 kcal" },
                { label: "Protein", value: "3g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "16g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "28g" },
                { label: "Sodium", value: "180mg" },
                { label: "Cholesterol", value: "55mg" }
            ]
        },
        {
            id: 32,
            image: images.dessert8,
            title: "Tiramisu",
            content: "A classic Italian dessert made with layers of coffee-soaked ladyfingers and creamy mascarpone filling.",
            details: {
                price: "9",
                rating: "4.8/5 (based on 410 reviews)",
                portionSize: "250g",
                preparationTime: "30 mins",
                allergens: "Gluten, Dairy, Eggs",
                servingTemperature: "Chilled",
                dietaryInfo: "Moderate-Fat, High-Sugar",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Espresso"
            },
            paragraphs: [
                "Indulge in the smooth, creamy layers of our Tiramisu, featuring rich mascarpone cheese, freshly brewed coffee, and a light dusting of cocoa powder.",
                "This elegant dessert is perfect for any occasion, offering the perfect balance of sweetness and the robust flavor of coffee."
            ],
            ingredients: [
                "Ladyfingers",
                "Mascarpone Cheese",
                "Heavy Cream",
                "Egg Yolks",
                "Sugar",
                "Coffee",
                "Cocoa Powder",
                "Vanilla Extract",
                "Dark Rum"
            ],
            nutritions: [
                { label: "Calories", value: "450 kcal" },
                { label: "Protein", value: "8g" },
                { label: "Carbohydrates", value: "50g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "30g" },
                { label: "Sodium", value: "120mg" },
                { label: "Cholesterol", value: "90mg" }
            ]
        }
    ],

    beveragesCategory: [
        {
            id: 33,
            image: images.beverage1,
            title: "Apple Juice",
            content: "A refreshing and sweet drink made from fresh apples, perfect for quenching your thirst.",
            details: {
                price: "4",
                rating: "4.7/5 (based on 150 reviews)",
                portionSize: "300ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Chilled",
                dietaryInfo: "Low-Fat, High-Vitamin C",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Fruit Salad"
            },
            paragraphs: [
                "Enjoy the crisp and natural taste of freshly pressed apples with our Apple Juice. It’s a perfect drink to refresh yourself on a hot day.",
                "Made with the finest apples, this juice is rich in flavor and nutrients, offering a perfect balance of sweetness and tang."
            ],
            ingredients: [
                "Fresh Apples",
                "Water",
                "Sugar (Optional)",
                "Lemon Juice"
            ],
            nutritions: [
                { label: "Calories", value: "150 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "35g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "30g" },
                { label: "Sodium", value: "5mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 34,
            image: images.beverage2,
            title: "Coffee",
            content: "A rich and aromatic cup of coffee, perfect for your morning boost or a relaxing break.",
            details: {
                price: "5",
                rating: "4.8/5 (based on 320 reviews)",
                portionSize: "250ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Low-Calorie, Caffeine-Boosting",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Pastry"
            },
            paragraphs: [
                "Savor the bold and full-bodied flavor of our freshly brewed coffee, made from the finest coffee beans.",
                "Whether you prefer it black or with milk, this classic coffee is sure to energize and satisfy."
            ],
            ingredients: [
                "Ground Coffee Beans",
                "Water",
                "Milk (Optional)",
                "Sugar (Optional)"
            ],
            nutritions: [
                { label: "Calories", value: "80 kcal" },
                { label: "Protein", value: "1g" },
                { label: "Carbohydrates", value: "15g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "15g" },
                { label: "Sodium", value: "10mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 35,
            image: images.beverage3,
            title: "Hot Chocolate",
            content: "A rich and creamy hot chocolate, perfect for warming up on a cold day.",
            details: {
                price: "6",
                rating: "4.7/5 (based on 280 reviews)",
                portionSize: "250ml",
                preparationTime: "10 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "High-Sugar, Moderate-Fat",
                spiceLevel: "Sweet",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Marshmallows"
            },
            paragraphs: [
                "Indulge in our smooth and velvety Hot Chocolate, made with premium cocoa and topped with whipped cream.",
                "This comforting drink is the perfect choice for a cozy afternoon or a treat during the colder months."
            ],
            ingredients: [
                "Cocoa Powder",
                "Milk",
                "Sugar",
                "Whipped Cream",
                "Chocolate Shavings"
            ],
            nutritions: [
                { label: "Calories", value: "250 kcal" },
                { label: "Protein", value: "6g" },
                { label: "Carbohydrates", value: "40g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "35g" },
                { label: "Sodium", value: "100mg" },
                { label: "Cholesterol", value: "25mg" }
            ]
        },
        {
            id: 36,
            image: images.beverage4,
            title: "Iced Tea",
            content: "A refreshing and chilled iced tea, perfect for a hot day.",
            details: {
                price: "5",
                rating: "4.5/5 (based on 180 reviews)",
                portionSize: "300ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Low-Sugar, Caffeine-Free",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Lemon Slice"
            },
            paragraphs: [
                "Cool off with our crisp and refreshing Iced Tea, brewed to perfection and served chilled with ice cubes.",
                "This simple yet flavorful drink is a great thirst quencher, ideal for warm weather or any time you need a refreshing break."
            ],
            ingredients: [
                "Black Tea",
                "Sugar",
                "Lemon",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "60 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "15g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "15g" },
                { label: "Sodium", value: "10mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 37,
            image: images.beverage5,
            title: "Lemonade",
            content: "A tangy and refreshing lemonade, the perfect drink to quench your thirst.",
            details: {
                price: "6",
                rating: "4.7/5 (based on 210 reviews)",
                portionSize: "300ml",
                preparationTime: "10 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Low-Sugar, Caffeine-Free",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Mint Leaves"
            },
            paragraphs: [
                "Enjoy a burst of citrusy refreshment with our freshly made Lemonade, a perfect blend of tart lemons and a hint of sweetness.",
                "This cool, revitalizing drink is a great choice for hot days or as a refreshing treat at any time."
            ],
            ingredients: [
                "Fresh Lemons",
                "Sugar",
                "Water",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "100 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "25g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "24g" },
                { label: "Sodium", value: "10mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 38,
            image: images.beverage6,
            title: "Milkshake",
            content: "A creamy and indulgent milkshake, blended with your choice of flavors and topped with whipped cream.",
            details: {
                price: "8",
                rating: "4.8/5 (based on 320 reviews)",
                portionSize: "350ml",
                preparationTime: "15 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Cold",
                dietaryInfo: "High-Sugar, High-Fat",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Chocolate Chip Cookies"
            },
            paragraphs: [
                "Treat yourself to our smooth and rich Milkshake, made with creamy milk and your favorite flavor, from chocolate to vanilla.",
                "This delightful beverage is topped with whipped cream and a cherry for an extra touch of sweetness."
            ],
            ingredients: [
                "Milk",
                "Ice Cream",
                "Sugar",
                "Vanilla Extract",
                "Whipped Cream",
                "Chocolate Syrup (optional)",
                "Fruit (optional)"
            ],
            nutritions: [
                { label: "Calories", value: "400 kcal" },
                { label: "Protein", value: "8g" },
                { label: "Carbohydrates", value: "55g" },
                { label: "Fat", value: "20g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "50g" },
                { label: "Sodium", value: "150mg" },
                { label: "Cholesterol", value: "40mg" }
            ]
        },
        {
            id: 39,
            image: images.beverage7,
            title: "Orange Juice",
            content: "Freshly squeezed orange juice, bursting with natural sweetness and vitamin C.",
            details: {
                price: "6",
                rating: "4.7/5 (based on 280 reviews)",
                portionSize: "250ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Low-Sugar, High-Vitamin C",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Croissants"
            },
            paragraphs: [
                "Start your day with a refreshing glass of freshly squeezed Orange Juice, packed with the tangy flavor of ripe oranges.",
                "This nutrient-packed beverage is a great source of vitamin C and is sure to give you a revitalizing boost."
            ],
            ingredients: [
                "Fresh Oranges"
            ],
            nutritions: [
                { label: "Calories", value: "110 kcal" },
                { label: "Protein", value: "2g" },
                { label: "Carbohydrates", value: "27g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "21g" },
                { label: "Sodium", value: "0mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 40,
            image: images.beverage8,
            title: "Tea",
            content: "A soothing cup of brewed tea, perfect for any time of the day.",
            details: {
                price: "4",
                rating: "4.5/5 (based on 300 reviews)",
                portionSize: "200ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Low-Calorie",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Delivery",
                recommendedPairing: "Scones"
            },
            paragraphs: [
                "Enjoy a warm and calming cup of tea, made with the finest tea leaves for a truly comforting experience.",
                "Whether you prefer it plain or with a touch of milk, this classic beverage is sure to please with its subtle flavors."
            ],
            ingredients: [
                "Tea Leaves",
                "Water"
            ],
            nutritions: [
                { label: "Calories", value: "2 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "0g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "0g" },
                { label: "Sodium", value: "0mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        }

    ],

};

export default menu;